import { Injectable } from "@angular/core";

declare let gtag;

@Injectable({ providedIn: "root" })
export class GoogleAnalyticsService {
  public record(
    eventCategory: string,
    eventName: string,
    eventLabel: string = null,
    eventValue: number = null,
  ) {
    gtag("event", eventName, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue,
    });
  }
}
